import { Box, SxProps, Theme, Typography } from '@mui/material'
import React from 'react'
import logo from '../logo.svg'
import { colors, lightBlue } from '../theme'

interface LayoutProps {
  children: React.ReactNode
}

export const GuestAdoptionLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box sx={{ height: '100vh', maxHeight: '100dvh', overflowY: 'auto', backgroundColor: lightBlue }}>
      <Box
        component="header"
        sx={{ display: 'flex', justifyContent: 'center', py: 1.5, backgroundColor: 'white', boxShadow: 1 }}
      >
        <img src={logo} alt="Petso" height={36} />
      </Box>
      <Box
        component="main"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          maxWidth: '560px',
          mx: 'auto',
          p: 2,
          pb: 'calc(48px + env(safe-area-inset-bottom, 0px))',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

interface TitleProps {
  children: React.ReactNode
  sx?: SxProps<Theme>
}

export const GuestAdoptionTitle: React.FC<TitleProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        backgroundColor: colors.blueSky,
        color: 'white',
        fontSize: '20px',
        fontWeight: 700,
        width: 'fit-content',
        p: 1,
        py: 0.5,
        pr: 2,
        borderRadius: '11px',
        transform: 'rotate(-1deg)',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

interface CardProps {
  children: React.ReactNode
}

export const GuestAdoptionCard: React.FC<CardProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        backgroundColor: 'white',
        borderRadius: 2,
        border: '1px solid rgba(74, 119, 255, 0.16)',
        boxShadow: '0 10px 28px rgba(7, 41, 72, 0.08)',
        p: 2,
      }}
    >
      {children}
    </Box>
  )
}

interface AmountRowProps {
  label: React.ReactNode
  amount: string
  alignItems?: 'center' | 'start'
}

export const GuestAdoptionAmountRow: React.FC<AmountRowProps> = ({ label, amount, alignItems = 'center' }) => {
  return (
    <Box sx={{ display: 'flex', alignItems, justifyContent: 'space-between', gap: 1, width: '100%', px: 1 }}>
      <Typography variant="body1" component="div" sx={{ color: 'rgba(87, 87, 87, 1)', fontStyle: 'italic' }}>
        {label}
      </Typography>
      <Typography variant="body1" sx={{ color: 'rgba(87, 87, 87, 1)', fontWeight: 700, whiteSpace: 'nowrap' }}>
        {amount}
      </Typography>
    </Box>
  )
}
